import { FetchResult, gql } from '@apollo/client';
import { client } from 'shared/containers/apollo';
import { GetVppIframeCredsResponse } from '@buy-viasat/types/build/bv';

const GET_VPP_IFRAME_CREDS = gql`
  query getVPPIframeCreds {
    getVPPIframeCreds {
      dataSecret
      url
    }
  }
`;
export type GetVPPIframeCredsPayload = FetchResult<{ getVPPIframeCreds: GetVppIframeCredsResponse }>;

export default async function getVPPIframeCredsAsync(): Promise<GetVPPIframeCredsPayload> {
  return client.query({
    query: GET_VPP_IFRAME_CREDS,
    fetchPolicy: 'cache-first',
  });
}
